import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import Home from "./pages/Home";
import Admin from "./pages/Admin";
import Accueil from "./pages/Accueil";
import { PaymentSuccess, PaymentCancel } from "./pages/Payment";
import Wengo, { VisitorPing } from "./pages/Wengo";
import { AuthCallback } from "./pages/AuthCallback";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/accueil" element={<Accueil />} />
      <Route path="/wengo" element={<Wengo />} />
      <Route path="/admin" element={<Admin />} />
      <Route path="/payment/success" element={<PaymentSuccess />} />
      <Route path="/payment/cancel" element={<PaymentCancel />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <VisitorPing />
      <AppRouter />
      <Toaster theme="dark" position="top-center" />
    </BrowserRouter>
  );
}

export default App;
